import React, {useState} from 'react';
import Modal from 'modal-enhanced-react-native-web';
import { View, Text, Platform, Dimensions } from 'react-native';


export default function ModalWeb ({ children, showModal }) {

    const [window, setWindow] = useState(Dimensions.get('window'))
    let margin = window.width / 2

    return(
        <Modal
            animationType='slide'
            transparent={true}
            visible={showModal}
            isVisible={2}
            style={{flex:1, justifyContent: 'flex-end', alignSelf:'center', margin:50, width:margin }}
        >
            {children}
        </Modal>
    )
}
